(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 80029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ GoogleSignInButton; }
/* harmony export */ });
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1025);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65400);
/* harmony import */ var antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54277);
/* harmony import */ var antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_space__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74048);
/* harmony import */ var antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47811);
/* harmony import */ var antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd_lib_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var GoogleSignInButton = function GoogleSignInButton(_ref) {
  var text = _ref.text,
      handleSignIn = _ref.handleSignIn;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_4__["default"], {
    className: "bg-gray-100 text-gray-700 border-none text-sm",
    block: true,
    size: "large",
    onClick: handleSignIn,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd_lib_space__WEBPACK_IMPORTED_MODULE_5__["default"], {
      direction: "horizontal",
      align: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        preview: false,
        style: {
          width: 32
        },
        className: "inline-block",
        src: "/thirdParties/google_g.png"
      }), text]
    })
  });
};

/***/ }),

/***/ 88215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_lib_alert_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92015);
/* harmony import */ var antd_lib_alert_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_alert_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4863);
/* harmony import */ var antd_lib_typography_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23461);
/* harmony import */ var antd_lib_typography_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_typography_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53740);
/* harmony import */ var classname__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80411);
/* harmony import */ var classname__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classname__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61891);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5233);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80818);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var AlertNotAvailable = function AlertNotAvailable() {
  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)('landingpage-admin/partner'),
      t = _useTranslation.t;

  var _useAuth = (0,components_auth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)(),
      authUser = _useAuth.authUser;

  var handleClick = function handleClick() {
    window.history.pushState({}, 'integration_request', '?integration_request=true');

    if (window.HubSpotConversations && window.HubSpotConversations.widget) {
      setTimeout(function () {
        window.HubSpotConversations.widget.open();
      }, 200); // Short delay to ensure close completes before refresh

      (0,utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .trackEvent */ .L9)('User clicked reach out for Integration', {
        chat: true
      }, authUser === null || authUser === void 0 ? void 0 : authUser.uuid);
    } else {
      // If HubSpot chat widget is not available, fall back to mailto link
      var _mailtoLink = "mailto:request@traqqie.com?subject=Please%20add%20%5BYour%20Integration%5D&body=Dear%20Traqqie%20Team,%0D%0A%0D%0AI%20would%20like%20to%20use%20Traqqie.%20Could%20you%20please%20add%20%5BYour%20Integration%5D%20to%20Traqqie?%0D%0A%0D%0AThank%20you.%0D%0AYOUR%20NAME";

      var _emailLink = document.createElement('a');

      _emailLink.href = _mailtoLink;
      _emailLink.target = '_blank';

      _emailLink.click();

      (0,utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .trackEvent */ .L9)('User clicked reach out for Integration', {
        chat: false
      }, authUser === null || authUser === void 0 ? void 0 : authUser.uuid);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(antd_lib_alert__WEBPACK_IMPORTED_MODULE_7__["default"], {
    message: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
      children: [t('alertMessage'), ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(antd_lib_typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Link */ .Z.Link, {
        onClick: handleClick,
        children: t('reachOutLink')
      })]
    }),
    type: "success",
    style: {
      backgroundColor: '#f6ffed',
      borderColor: '#b7eb8f',
      borderRadius: 8,
      padding: '12px 24px'
    },
    showIcon: false
  });
};

var PartnerSection = function PartnerSection(_ref) {
  var title = _ref.title,
      partners = _ref.partners,
      _ref$showAlert = _ref.showAlert,
      showAlert = _ref$showAlert === void 0 ? false : _ref$showAlert;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("section", {
    id: "partner",
    className: "flex flex-col items-center py-12 px-6 gap-y-12 md:py-24 lg:px-[100px]",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
      className: "font-inter font-medium text-base text-gr600 text-center",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
      className: classname__WEBPACK_IMPORTED_MODULE_2___default()('w-full flex flex-col items-center gap-y-10 flex-wrap', 'sm:gap-x-8 sm:flex-row sm:justify-center sm:items-start', 'xl:gap-x-16'),
      children: partners.map(function (_ref2) {
        var text = _ref2.text,
            path = _ref2.path,
            width = _ref2.width,
            height = _ref2.height;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
          width: width,
          height: height,
          alt: text,
          src: path,
          className: "h-8 w-auto object-cover block lg:h-12"
        }, text);
      })
    }), showAlert && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(AlertNotAvailable, {})]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PartnerSection);

/***/ }),

/***/ 98804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SJ": function() { return /* binding */ PARTNERS_APPLICATIONS; },
/* harmony export */   "ql": function() { return /* binding */ PARTNERS_ADMIN; }
/* harmony export */ });
/* unused harmony exports WORK_TEXTS, PRICING_PERIODS, PRICING_OPT */
var PARTNERS_ADMIN = [{
  text: 'Trello',
  path: '/images/partners/trello.png',
  width: 142,
  height: 48
}, {
  text: 'Asana',
  path: '/images/partners/asana.png',
  width: 74,
  height: 48
}, {
  text: 'Linear',
  path: '/images/partners/linear.png',
  width: 192,
  height: 48
}, {
  text: 'Atlassian',
  path: '/images/partners/atlasian.png',
  width: 309,
  height: 48
}, {
  text: 'Shortcut',
  path: '/images/partners/shortcut.png',
  width: 175,
  height: 48
}];
var PARTNERS_APPLICATIONS = [{
  text: 'Firebase',
  path: '/images/partners/firebase.png',
  width: 142,
  height: 48
}, {
  text: 'AWS',
  path: '/images/partners/aws.svg',
  width: 74,
  height: 48
}, {
  text: 'OpenAI',
  path: '/images/partners/openai.png',
  width: 309,
  height: 48
}];
var WORK_TEXTS = [{
  title: 'Effortless Time-Logging',
  icon: '/icons/simple.svg',
  desc: 'Rapid Recording: Time-tracking made easy. Just drag, drop, and consider it done.'
}, {
  title: 'Seamless Integration',
  icon: '/icons/integrated.svg',
  desc: 'One Stop Shop: Traqqie melds with your project mangement system & calendar,you have all important information in one place.'
}, {
  title: 'Always Compliant',
  icon: '/icons/keep-track.svg',
  desc: 'Stay in the Safe Zone: With auto-checks on all time entries, compliance is a given. Extra information makes back-tracing easy.'
}, {
  title: 'Timely Reminders',
  icon: '/icons/reminders.svg',
  desc: 'On Your Schedule: Receive reminders and stay consistently updated with your WBSO logs'
}];
var PRICING_PERIODS = [{
  text: 'Monthly billing',
  value: 'monthly'
}, {
  text: 'Annual billing',
  value: 'annual'
}];
var PRICING_OPT = {
  monthly: [{
    price: '€10',
    title: 'Starter plan',
    subtitle: 'Ideal for Small Teams & Start Ups',
    isPopular: true,
    benefits: [{
      text: 'per hour registered 0.50 € ( only ~ 2.5% of WBSO potential)',
      isGiven: true
    }, // { text: 'Reminder emails', isGiven: true },
    {
      text: 'Unlimited Employees (max. 15)',
      isGiven: false
    }]
  }, {
    price: '€17',
    title: 'Expansion plan',
    subtitle: 'Ideal for Scale Ups & Corporates',
    isPopular: false,
    benefits: [{
      text: 'per hour registered 0.30  € ( only ~ 1.5% of WBSO potential)',
      isGiven: true
    }, // { text: 'Reminder emails', isGiven: true },
    {
      text: 'Unlimited Employees',
      isGiven: true
    }]
  }],
  annual: [{
    price: '€100',
    title: 'Starter plan',
    subtitle: 'Ideal for Small Teams & Start Ups',
    isPopular: true,
    benefits: [{
      text: 'per hour registered 0.50 € ( only ~ 2.5% of WBSO potential)',
      isGiven: true
    }, // { text: 'Reminder emails', isGiven: true },
    {
      text: 'Unlimited Employees (max. 15)',
      isGiven: false
    }]
  }, {
    price: '€170',
    title: 'Expansion plan',
    subtitle: 'Ideal for Scale Ups & Corporates',
    isPopular: false,
    benefits: [{
      text: 'per hour registered 0.30  € ( only ~ 1.5% of WBSO potential)',
      isGiven: true
    }, // { text: 'Reminder emails', isGiven: true },
    {
      text: 'Unlimited Employees',
      isGiven: true
    }]
  }]
};

/***/ }),

/***/ 18715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignInOrDemo_SignInOrDemo; }
});

// EXTERNAL MODULE: ./node_modules/antd/lib/row/style/index.js
var style = __webpack_require__(30467);
// EXTERNAL MODULE: ./node_modules/antd/lib/row/index.js
var row = __webpack_require__(55673);
// EXTERNAL MODULE: ./node_modules/antd/lib/divider/style/index.js
var divider_style = __webpack_require__(56120);
// EXTERNAL MODULE: ./node_modules/antd/lib/divider/index.js
var divider = __webpack_require__(74253);
// EXTERNAL MODULE: ./node_modules/antd/lib/col/style/index.js
var col_style = __webpack_require__(58136);
// EXTERNAL MODULE: ./node_modules/antd/lib/col/index.js
var col = __webpack_require__(5789);
// EXTERNAL MODULE: ./node_modules/antd/lib/card/style/index.js
var card_style = __webpack_require__(89626);
// EXTERNAL MODULE: ./node_modules/antd/lib/card/index.js
var card = __webpack_require__(70302);
// EXTERNAL MODULE: ./node_modules/antd/lib/typography/style/index.js
var typography_style = __webpack_require__(23461);
// EXTERNAL MODULE: ./node_modules/antd/lib/typography/index.js
var typography = __webpack_require__(53740);
// EXTERNAL MODULE: ./src/components/GoogleSignInButton/GoogleSignInButton.js
var GoogleSignInButton = __webpack_require__(80029);
// EXTERNAL MODULE: ./node_modules/antd/lib/button/style/index.js
var button_style = __webpack_require__(1025);
// EXTERNAL MODULE: ./node_modules/antd/lib/button/index.js
var lib_button = __webpack_require__(65400);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/style/index.js
var form_style = __webpack_require__(29809);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/index.js
var lib_form = __webpack_require__(97538);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/style/index.js
var input_style = __webpack_require__(89858);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/index.js
var input = __webpack_require__(51024);
// EXTERNAL MODULE: ./node_modules/antd/lib/message/style/index.js
var message_style = __webpack_require__(75314);
// EXTERNAL MODULE: ./node_modules/antd/lib/message/index.js
var message = __webpack_require__(11187);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/index.js
var services = __webpack_require__(72220);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SignInOrDemo/CollectEmailForDemo.js















var CollectEmailForDemo = function CollectEmailForDemo(_ref) {
  var handleDemoClick = _ref.handleDemoClick;

  var _useState = (0,react.useState)(false),
      showEmailForm = _useState[0],
      setShowEmailForm = _useState[1];

  var _useTranslation = (0,esm/* useTranslation */.$G)('signup'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showEmailForm && /*#__PURE__*/(0,jsx_runtime.jsxs)(lib_form/* default */.Z, {
      onFinish: function onFinish(values) {
        services/* ApiCall.WaitList.demoSignUp */.o.WaitList.demoSignUp(values).then(function () {
          handleDemoClick();
        })["catch"](function (error) {
          message["default"].error('An error occurred. Please try again.');
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib_form/* default.Item */.Z.Item, {
        name: "email",
        label: t('email'),
        rules: [{
          required: true,
          message: t('email_required')
        }, {
          type: 'email',
          message: t('email_invalid')
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
          type: "email"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib_button["default"], {
        className: "bg-g400 text-white",
        htmlType: "submit",
        children: t('start_demo')
      })]
    }), !showEmailForm && /*#__PURE__*/(0,jsx_runtime.jsx)(lib_button["default"], {
      className: " bg-g400 text-white",
      onClick: function onClick() {
        return setShowEmailForm(true);
      },
      children: t('demo_or_signup_cta')
    })]
  });
};

/* harmony default export */ var SignInOrDemo_CollectEmailForDemo = (CollectEmailForDemo);
;// CONCATENATED MODULE: ./src/components/SignInOrDemo/SignInOrDemo.js
















var SignInOrDemo = function SignInOrDemo(_ref) {
  var handleSignIn = _ref.handleSignIn,
      handleDemoClick = _ref.handleDemoClick;

  var _useTranslation = (0,esm/* useTranslation */.$G)('signup'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "demo",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
      align: "middle",
      justify: "center",
      className: "h-screen p-4",
      gutter: 24,
      style: {
        display: 'flex',
        justifyContent: 'center'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        xs: 24,
        sm: 10,
        lg: 8,
        xl: 6,
        style: {
          display: 'flex',
          justifyContent: 'center'
        },
        className: "text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
          style: {
            width: '100%',
            maxWidth: '400px',
            height: 'auto',
            minHeight: '340px',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Title */.Z.Title, {
            level: 3,
            children: t('demo_or_signup_title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Paragraph */.Z.Paragraph, {
            children: t('demo_or_signup_description')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInOrDemo_CollectEmailForDemo, {
            handleDemoClick: handleDemoClick
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
        xs: 0,
        sm: 2,
        lg: 1,
        xl: 1,
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        },
        className: "text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
          type: "vertical",
          style: {
            height: '40%',
            minHeight: '150px'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: {
            fontWeight: 'bold',
            color: '#333',
            margin: '4px',
            fontSize: '18px',
            padding: '0 8px'
          },
          children: t('or')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
          type: "vertical",
          style: {
            height: '40%',
            minHeight: '150px'
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        xs: 24,
        sm: 10,
        lg: 8,
        xl: 6,
        style: {
          display: 'flex',
          justifyContent: 'center'
        },
        className: "text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
          style: {
            width: '100%',
            maxWidth: '400px',
            height: 'auto',
            minHeight: '340px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Title */.Z.Title, {
            level: 3 // className="text-xl font-semibold text-center"
            ,
            children: t('demo_or_signup_traqqie_users')
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
            align: "middle",
            justify: "center",
            className: "px-4",
            gutter: [16, 24],
            children: [t('demo_or_signup_member_explanation'), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
              span: 24,
              className: "text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleSignInButton/* GoogleSignInButton */.N, {
                handleSignIn: handleSignIn,
                text: t('login_with_google').toUpperCase()
              })
            }), t('or'), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
              span: 24,
              className: "text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleSignInButton/* GoogleSignInButton */.N, {
                handleSignIn: handleSignIn,
                text: t('signup_with_google').toUpperCase()
              })
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var SignInOrDemo_SignInOrDemo = (SignInOrDemo);

/***/ }),

/***/ 43381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ generateAlternatesAndCanonical; }
/* harmony export */ });
/* unused harmony export LANDINGPAGE */
var LANDINGPAGE = {
  title: 'Increase WBSO Claims by 60% - Automate WBSO Time Tracking with Traqqie',
  description: 'Eliminate the chase for engineer timesheets and streamline your WBSO submissions with Traqqie. Our automated platform boosts your claims by 60%, ensures compliance, and saves significant time. Discover how Traqqie can transform your subsidy management and let you focus on innovation.'
};
var generateAlternatesAndCanonical = function generateAlternatesAndCanonical(locale) {
  var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var DEFAULT_LANGUAGE = 'en';
  var supportedLanguages = [{
    lang: 'en',
    path: '/en'
  }, {
    lang: 'nl',
    path: '/nl'
  }, {
    lang: 'x-default',
    path: ''
  } // Add more languages as needed
  ]; // Assuming your site's base URL is example.com

  var baseUrl = 'https://traqqie.com'; // Generate the language alternates array

  return {
    alternates: supportedLanguages.map(function (_ref) {
      var lang = _ref.lang,
          path = _ref.path;
      return {
        hrefLang: lang,
        href: route === undefined ? "".concat(baseUrl).concat(path) : "".concat(baseUrl).concat(path, "/").concat(route) // Adjust the path as necessary

      };
    }),
    canonoical: locale !== DEFAULT_LANGUAGE ? "".concat(baseUrl, "/").concat(locale, "/").concat(route === undefined ? '' : "".concat(route)) : "".concat(baseUrl, "/").concat(route === undefined ? '' : "".concat(route))
  };
};

/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ src_pages; }
});

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CaseStudy.js




var CaseStudySection = function CaseStudySection() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/case-study'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "case-study",
    className: "w-full flex flex-col items-center py-12 px-4 md:py-24 md:px-6 gap-y-12 md:gap-y-16 bg-[#F9FAFB] lg:px-[100px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center gap-y-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "mb-0 font-semibold font-inter text-gr900 text-center text-2xl md:text-3xl lg:text-4xl",
        children: t('caseStudyHeading')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-inter text-gr600 text-center mt-2 text-base md:text-lg",
        children: t('caseStudySubheading')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full flex flex-col items-center gap-y-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center text-center max-w-4xl px-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "font-inter mb-0 font-semibold text-xl md:text-2xl text-gr900 mt-5",
          children: t('caseStudySaveTimeCutCosts')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "overflow-x-auto mt-5 w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
            className: "w-full border-collapse text-xs md:text-sm lg:text-base",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                className: "bg-gray-100",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                  className: "border-b-2 border-gray-300 p-2 md:p-4",
                  children: t('caseStudyScenario')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                  className: "border-b-2 border-gray-300 p-2 md:p-4",
                  children: t('caseStudyWithoutTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                  className: "border-b-2 border-gray-300 p-2 md:p-4",
                  children: t('caseStudyWithTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                  className: "border-b-2 border-gray-300 p-2 md:p-4",
                  children: t('caseStudySavings')
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyTimeSpentWBSOAdmin')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyTimeWithoutTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyTimeWithTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyTimeSavings')
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                className: "bg-gray-50",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyCostOfTime')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyCostWithoutTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyCostWithTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyCostSavings')
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudyTraqqieSubscription')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudySubscriptionWithoutTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: t('caseStudySubscriptionWithTraqqie')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: "-"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4 font-semibold",
                  children: t('caseStudyNetSavingsYearly')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: "-"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: "-"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: "border-b border-gray-200 p-2 md:p-4",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: t('caseStudyNetSavingsAmount')
                  })
                })]
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "font-inter text-gr600 mt-2 text-xs md:text-sm",
          children: t('caseStudySalaryAssumption')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center text-left max-w-4xl px-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-inter mb-0 font-semibold text-xl md:text-2xl text-gr900 mt-5",
          children: t('caseStudyEnjoyPeaceOfMind')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "list-none mt-5 space-y-2 md:space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "font-inter text-gr600 text-sm md:text-base",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: t('caseStudyHappyEngineers')
            }), ' ', t('caseStudyHappyEngineersDescription')]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "font-inter text-gr600 text-sm md:text-base",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: t('caseStudyComplianceSimplified')
            }), ' ', t('caseStudyComplianceSimplifiedDescription')]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "font-inter text-gr600 text-sm md:text-base",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: t('caseStudyStreamlinedProcesses')
            }), ' ', t('caseStudyStreamlinedProcessesDescription')]
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var CaseStudy = (CaseStudySection);
// EXTERNAL MODULE: ./src/components/FooterV2/FooterV2.js
var FooterV2 = __webpack_require__(47327);
// EXTERNAL MODULE: ./src/components/HeaderV2/HeaderV2.js + 1 modules
var HeaderV2 = __webpack_require__(79491);
// EXTERNAL MODULE: ./src/components/SignInOrDemo/SignInOrDemo.js + 1 modules
var SignInOrDemo = __webpack_require__(18715);
// EXTERNAL MODULE: ./src/components/auth/index.js + 17 modules
var auth = __webpack_require__(61891);
// EXTERNAL MODULE: ./node_modules/classname/classname.js
var classname = __webpack_require__(80411);
var classname_default = /*#__PURE__*/__webpack_require__.n(classname);
// EXTERNAL MODULE: ./src/components/ButtonV2/NavigationalButton.js
var NavigationalButton = __webpack_require__(35888);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/pages.js
var pages = __webpack_require__(34052);
;// CONCATENATED MODULE: ./src/components/LandingPage/components/Hero.js









var Hero = function Hero() {
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/hero'),
      t = _useTranslation.t;

  var fullTitle = t('hero_title');

  var _useState = (0,react.useState)(fullTitle),
      displayedTitle = _useState[0],
      setDisplayedTitle = _useState[1]; // Default to full title for SSR


  var indexRef = (0,react.useRef)(0);
  (0,react.useEffect)(function () {
    // Check if window object is available to determine if it's running on the client
    if (true) {
      // Initialize state for client-side
      setDisplayedTitle('');
      indexRef.current = 0;

      var _typeTitle2 = function _typeTitle() {
        setDisplayedTitle(fullTitle.slice(0, indexRef.current + 1));
        indexRef.current++; // Continue typing if there are characters left

        if (indexRef.current < fullTitle.length) {
          var _delay;

          if (fullTitle.charAt(indexRef.current) === '-') {
            _delay = 300; // Longer pause at the hyphen
          } else if (indexRef.current <= fullTitle.indexOf('-')) {
            _delay = 80; // Quicker initial typing up to the hyphen
          } else {
            _delay = 50; // Quicker than default speed for the rest
          }

          setTimeout(_typeTitle2, _delay);
        }
      }; // Start typing with a slight delay


      var _initialTimeout = setTimeout(_typeTitle2, 100); // Cleanup timeout if the component unmounts


      return function () {
        return clearTimeout(_initialTimeout);
      };
    }
  }, [fullTitle]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "hero",
    className: classname_default()('w-full min-h-max bg-g400 text-center flex flex-col items-center pt-20 px-6', 'lg:px-[100px]'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: classname_default()('font-inter font-semibold text-white text-3xl max-w-xs mb-0', 'md:text-5xl md:leading-[60px] md:max-w-3xl'),
      children: displayedTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: classname_default()('text-white font-inter text-base mt-4', 'md:text-xl md:mt-5'),
      children: t('hero_subtitle')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-row flex-wrap items-center gap-y-2 justify-center gap-x-4 mt-8 md:mt-8 mb-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationalButton/* default */.Z, {
        href: pages/* PAGE.signin */.qX.signin,
        variant: "outlined",
        onClick: function onClick() {
          return router.push(pages/* PAGE.signin */.qX.signin);
        },
        children: t('hero_cta')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationalButton/* default */.Z, {
        href: pages/* PAGE.signin */.qX.signin,
        variant: "outlined",
        className: "animate-pulse-animation",
        onClick: function onClick() {
          return router.push(pages/* PAGE.signin */.qX.signin);
        },
        children: t('hero_cta_calculator')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      width: 1136,
      height: 503,
      src: "/images/calendar.png",
      className: "w-full h-auto object-cover mt-12 max-w-[1136px] md:mt-16",
      alt: "Calendar"
    })]
  });
};

/* harmony default export */ var components_Hero = (Hero);
// EXTERNAL MODULE: ./src/components/LandingPage/components/PartnerSection.js
var PartnerSection = __webpack_require__(88215);
;// CONCATENATED MODULE: ./src/components/LandingPage/components/PricingSection.js









var PricingSection = function PricingSection() {
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)('annual'),
      pricingPeriod = _useState[0],
      setPricingPeriod = _useState[1];

  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/pricing'),
      t = _useTranslation.t;

  var PRICING_PERIODS = [{
    text: t('pricing_periods.monthly'),
    value: 'monthly'
  }, {
    text: t('pricing_periods.annual'),
    value: 'annual'
  }];
  var PRICING_FREQUENCIES = [{
    text: t('pricing_billing_frequency_monthly'),
    value: 'monthly'
  }, {
    text: t('pricing_billing_frequency_yearly'),
    value: 'annual'
  }];
  var PRICING_OPT = t("pricing_options.".concat(pricingPeriod), {
    returnObjects: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "pricing",
    className: "w-full flex flex-col items-center py-24 px-6 lg:px-[100px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center gap-y-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "mb-0 font-semibold font-inter text-gr900 text-center text-3xl md:text-5xl",
        children: t('pricing_title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-inter m-0 text-gr600 text-center text-lg md:text-xl",
        children: t('pricing_subtitle')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-10 flex items-center",
      children: PRICING_PERIODS.map(function (_ref) {
        var text = _ref.text,
            value = _ref.value;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: classname_default()('font-inter font-semibold bg-white px-[14px] py-[10px] rounded-md', {
            'text-gr700 shadow': pricingPeriod === value,
            'text-gr500': pricingPeriod !== value
          }),
          onClick: function onClick() {
            return setPricingPeriod(value);
          },
          children: text
        }, value);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classname_default()('mt-12 flex flex-col items-center gap-y-8 font-inter', 'md:mt-20 md:flex-row md:gap-x-8'),
      children: PRICING_OPT.map(function (d) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classname_default()('relative flex flex-col overflow-hidden items-center p-6 pt-8 bg-white border border-solid border-gr200 rounded-[18px] shadow-lg max-w-md', 'md:max-w-xl md:p-8 md:pt-10'),
          children: [d.isPopular && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            style: {
              transform: 'rotateZ(45deg) !important'
            },
            className: "absolute origin-top-left -right-20 -top-8 block px-10 py-1 bg-g400 text-sm text-white",
            children: t('pricing_popular_text')
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center text-center text-gr900",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-4xl font-semibold md:text-5xl",
              children: d.price
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "mb-0 mt-4 font-semibold text-xl",
              children: d.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-0 text-gr600 mt-1",
              children: d.subtitle
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-y-3 text-gr600 mt-8",
            children: d.benefits.map(function (_ref2) {
              var text = _ref2.text,
                  isGiven = _ref2.isGiven;
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex gap-x-1.5",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  alt: text,
                  src: isGiven ? '/icons/check.svg' : '/icons/close.svg',
                  width: 24,
                  height: 24,
                  className: "w-6 h-6"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-0",
                  children: text
                })]
              }, text);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationalButton/* default */.Z, {
            className: "!w-full mt-8",
            onClick: function onClick() {
              return router.push(pages/* PAGE.signin */.qX.signin);
            },
            href: pages/* PAGE.signin */.qX.signin,
            children: t('pricing_cta')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: '12px',
              marginTop: '5px'
            },
            children: PRICING_FREQUENCIES.find(function (f) {
              return f.value === pricingPeriod;
            }).text
          })]
        }, d.title);
      })
    })]
  });
};

/* harmony default export */ var components_PricingSection = (PricingSection);
;// CONCATENATED MODULE: ./src/components/LandingPage/components/TrialSection.js







var TrialSection = function TrialSection() {
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/trail'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "#trial",
    className: "w-full flex flex-col items-center py-24 px-6 gap-y-16 bg-[#F9FAFB] lg:px-[100px]",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full flex flex-col items-center max-w-[1216px] md:flex-row md:items-start md:justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center text-center gap-y-4 md:items-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "font-semibold text-4xl text-gr900",
          children: t('trial_title')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-gray-600",
          children: t('trial_subtitle')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationalButton/* default */.Z, {
        href: pages/* PAGE.signin */.qX.signin,
        className: "mt-12 md:mt-0",
        onClick: function onClick() {
          return router.push(pages/* PAGE.signin */.qX.signin);
        },
        children: t('trial_cta')
      })]
    })
  });
};

/* harmony default export */ var components_TrialSection = (TrialSection);
;// CONCATENATED MODULE: ./src/components/LandingPage/components/WorkSection.js





var WorkSection = function WorkSection() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/works'),
      t = _useTranslation.t;

  var workTexts = t('work_texts', {
    returnObjects: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "how-it-works",
    className: "w-full flex flex-col items-center py-24 px-6 gap-y-16 bg-[#F9FAFB] lg:px-[100px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col items-center gap-y-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "mb-0 font-semibold font-inter text-gr900 text-center text-3xl md:text-4xl",
        children: t('work_title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-inter text-gr600 text-center mt-2 text-lg md:text-lg",
        children: t('work_subtitle')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: classname_default()('w-full flex flex-col gap-y-8 items-center', 'md:flex-row md:gap-x-8 md:flex-wrap md:items-start md:justify-center'),
      children: workTexts.map(function (_ref) {
        var title = _ref.title,
            icon = _ref.icon,
            desc = _ref.desc;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex flex-col items-center text-center max-w-xs md:w-72",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            alt: title,
            src: icon,
            width: 36,
            height: 36,
            className: "w-9 h-9"
          }, title), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: "font-inter mb-0 font-semibold text-xl text-gr900 mt-5",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "font-inter text-gr600 mt-2",
            children: desc
          })]
        }, title);
      })
    })]
  });
};

/* harmony default export */ var components_WorkSection = (WorkSection);
// EXTERNAL MODULE: ./src/components/LandingPage/utils/constants.js
var constants = __webpack_require__(98804);
;// CONCATENATED MODULE: ./src/components/LandingPage/LandingPage.js















var LandingPageComponent = function LandingPageComponent(_ref) {
  var locale = _ref.locale;

  var _useAuth = (0,auth/* useAuth */.aC)(),
      signInWithGoogleAccount = _useAuth.signInWithGoogleAccount,
      createDemoAccount = _useAuth.createDemoAccount;

  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/partner'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "pt-[72px] md:pt-20 selection:bg-g400",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderV2/* default */.Z, {
      locale: locale
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Hero, {
      handleDemoClick: createDemoAccount
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PartnerSection/* default */.Z, {
      partners: constants/* PARTNERS_ADMIN */.ql,
      title: t('partner_title'),
      showAlert: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_WorkSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CaseStudy, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_TrialSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_PricingSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_TrialSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInOrDemo/* default */.Z, {
      handleSignIn: signInWithGoogleAccount,
      handleDemoClick: createDemoAccount
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterV2/* default */.Z, {})]
  });
};

/* harmony default export */ var LandingPage_LandingPage = (LandingPageComponent);
// EXTERNAL MODULE: ./src/data/seo/seo.js
var seo = __webpack_require__(43381);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./src/views/LandingPage/LandingPage.js








var LandingPage = function LandingPage(_ref) {
  var locale = _ref.locale;

  var _useTranslation = (0,esm/* useTranslation */.$G)('landingpage-admin/meta'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('meta_title'),
      description: t('meta_description'),
      languageAlternates: (0,seo/* generateAlternatesAndCanonical */.w)(locale).alternates,
      canonical: (0,seo/* generateAlternatesAndCanonical */.w)(locale).canonoical,
      openGraph: {
        title: t('meta_title'),
        description: t('meta_description')
      } // canonical=""

    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingPage_LandingPage, {
      locale: locale
    })]
  });
};

/* harmony default export */ var views_LandingPage_LandingPage = (LandingPage);
;// CONCATENATED MODULE: ./src/pages/index.js



var LandingPageLocalized = function LandingPageLocalized(_ref) {
  var locale = _ref.locale;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(views_LandingPage_LandingPage, {
    locale: locale
  });
};

var __N_SSP = true;
/* harmony default export */ var src_pages = (LandingPageLocalized);

/***/ }),

/***/ 72220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _ApiCall__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ApiCall__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78611);
/* harmony import */ var _Fetcher__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8210);



/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(25013);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1522,2962,5932,4577,6927,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);